import { render } from "./BPagination.vue?vue&type=template&id=18c4b491&ts=true"
import script from "./BPagination.vue?vue&type=script&lang=ts"
export * from "./BPagination.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__